import DSXIcon from './Icon';

export default DSXIcon;
